import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BehaviorSubject } from 'rxjs';
import { Inject } from '@angular/core';
import { CarrierData } from 'src/app/shared/sl-data/carrier';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-create-worker-modal',
  templateUrl: './create-worker-modal.component.html',
  styleUrls: ['./create-worker-modal.component.scss']
})
export class CreateWorkerModalComponent {
  editForm: FormGroup;
  operationInProg$ = new BehaviorSubject<'CREATE' | 'UPDATE' | 'DELETE' | null>(null);

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CreateWorkerModalComponent>,
    private carrierData: CarrierData,
    private utilities:UtilitiesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editForm = this.fb.group({
      firstName: [data.firstName || '', Validators.required],
      lastName: [data.lastName || '', Validators.required]
    });
  }

  async onEditFormSubmit(formValue: any) {
    if (!this.editForm.valid) {
        return;
    }
    try{
        this.operationInProg$.next(!this.data.userId ? 'CREATE' : 'UPDATE');
        if(!this.data.id){
          await this.carrierData.createCarrierWorker(formValue.firstName, formValue.lastName);
        }
        else{
            await this.carrierData.updateCarrierWorker(this.data.id, formValue.firstName, formValue.lastName);
        }
        
        this.dialogRef.close();
        this.utilities.notifySuccess(!this.data.id ? 'Carrier worker created successfully.' : 'Carrier worker updated successfully.');
      }
      catch(err){
          if(err.details){
              this.utilities.notifyError(err.details);
              return;
          }
          this.utilities.notifyError(!this.data.id ? 'Unexpected error creating carrier worker. Please contact system admin' : 'Unexpected error updating carrier user. Please contact system admin');
      }
      finally{
        this.operationInProg$.next(null);
      }
  }

  close() {
    this.dialogRef.close();
  }
} 